import React from "react";

function About() {
  return (
    <>
      <h2 className="mt-32 text-6xl text-center">
        These are words about SRCA.
      </h2>
    </>
  );
}

export default About;
